import { opinions } from '../defaults/opinions';

export const gemueseWraps = {
	name: 'Gemüsewraps mit Tofu',
	desc: 'Vegetarische Wraps mit würzigem angebratenem Tofu und würziger Grillsauce.',
	image: 3,
	benefits: [
		'Viele Proteine',
	],
	opinions: [
		{
			name: 'Jane Doe',
			date: '14. Januar 2017',
			title: 'Klein aber lecker',
			content: 'Recht kleine Portion, aber echt gut',
			rating: 4,
		},
		...opinions,
	],
	recommandation: 'Ein Joghurt als Nachtisch liefert noch etwas Calcium und hilft dem Magen bei der Verdauung.',
	warnings: ['soja', 'weizen', 'gluten', 'zucker'],
	ingredients: [
		{'Weizenmehl': 'weizen, gluten'},
		{'Tofu': 'soja'},
		'Basilikum',
		'Artischocken',
		'Zucchini',
		'Olivenöl',
		'Tomaten',
		'Pinienkerne',
		'Ruccola',

	],
};



// WEBPACK FOOTER //
// ./src/dishes/single-dishes/gemueseWraps.js